import { FC } from 'react';
import { Form, Modal } from 'react-bootstrap';

import { LoadingButton } from './loading-button';

interface InquiryCloseBeroeModalProps {
	show: boolean;
	value: boolean | null;
	isLoading?: boolean;
	onHide(): void;
	onChange(value: boolean): void;
	onConfirm(): void;
}

export const InquiryCloseBeroeModal: FC<InquiryCloseBeroeModalProps> = ({
	show,
	value,
	isLoading = false,
	onHide,
	onChange,
	onConfirm,
}) => {
	return (
		<Modal centered show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Close Inquiry</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p className="mb-4">Is Beroe-related content included in this inquiry response?</p>
				<Form>
					<Form.Check
						id="inquiry-close-beroe-yes"
						type="radio"
						name="inquiry-close-beroe"
						label="Yes"
						checked={value === true}
						onChange={() => {
							onChange(true);
						}}
					/>
					<Form.Check
						id="inquiry-close-beroe-no"
						type="radio"
						name="inquiry-close-beroe"
						label="No"
						checked={value === false}
						onChange={() => {
							onChange(false);
						}}
					/>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<div className="text-right">
					<LoadingButton
						variant="outline-primary"
						className="mr-2"
						onClick={onHide}
						disabled={isLoading}
					>
						Cancel
					</LoadingButton>
					<LoadingButton onClick={onConfirm} isLoading={isLoading} disabled={value === null}>
						Close Inquiry
					</LoadingButton>
				</div>
			</Modal.Footer>
		</Modal>
	);
};
